import type { AdminTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export async function getRoomsSiteConfigs(structureId: string) {
  return Api.get<AdminTypes.SiteConfig[]>(
    `admin/v1/site-configs/rooms/${structureId}`,
  ).then((res) => res.data);
}
